export async function getList({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.contacts.index(payload);

  return commit('setList', errResponse || !responseData.success ? [] : responseData.data);
}

export async function getDetail({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.contacts.show(payload);
  if (!errResponse && responseData.success) {
    return commit('setItem', responseData.data);
  }

  return [];
}

export async function getDetail1({commit}, payload) {
  const responseData = await this.$adminRepositories.contacts.show(payload);
  return responseData;
}


export async function updateStatus({commit}, payload) {
  const { errResponse, data: responseData } = await this.$adminRepositories.contacts.update(payload.id, {
    status: payload.status
  });

  if (!errResponse && responseData.success) {
    commit('setItem', responseData.data);
  }
  return responseData;
}

export async function addMemo({commit}, payload) {
  const { errResponse, data: responseData } = await this.$adminRepositories.contactMemos.store(payload)

  if (!errResponse && responseData.success) {
    commit('addMemo', responseData.data);
  }

  return responseData;
}

export async function deleteMultipleMemo({commit}, payload) {
  const { errResponse, data: responseData } = await this.$adminRepositories.contactMemos.deleteMultiple(payload)

  if (!errResponse && responseData.success) {
    commit('deleteMultipleMemo', payload);
  }

  return responseData;
}

